import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  imports: [],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class Login {
  public loginUrl = `${environment.backUrl}/auth/google/redirect?platform=app`;

  ngOnInit() {}
}
